import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi, setToken, clearToken, getToken } from "@/lib/apiClient";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadUser = useCallback(async () => {
        if (!getToken()) {
            setLoading(false);
            return;
        }
        try {
            const u = await authApi.me();
            setUser(u);
        } catch (e) {
            clearToken();
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadUser();
    }, [loadUser]);

    const login = async (email, password) => {
        const data = await authApi.login({ email, password });
        setToken(data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password, ref) => {
        const data = await authApi.register({ name, email, password, ref: ref || undefined });
        setToken(data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        clearToken();
        setUser(null);
    };

    const patchUser = useCallback((fields) => {
        setUser((u) => (u ? { ...u, ...fields } : u));
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh: loadUser, patchUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
};
